import { Flex, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import { CommentFragmentFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { colors } from '~/packages/common-frontend/colors';
import { RenderStaticHtml } from '~/packages/common-frontend/components/RichTextEditor/RichTextEditor';
import { Timestamp } from '~/packages/common-frontend/components/Timestamp';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { UserDetail } from '~/packages/common-frontend/components/UserDetail';

// Exports
type CommentBoxProps = {
  comment: CommentFragmentFragmentGQLType;
  actions?: React.ReactNode;
};
export const CommentBox = ({ comment, actions }: CommentBoxProps) => {
  const textColor = useColorModeValue(colors.gray[800], colors.gray[100]);
  return (
    <Flex direction="column" gap="0.25rem">
      <Flex alignItems="flex-start" gap="0.5rem">
        <UserDetail variant="avatar" user={comment.author} />
        <Typography inline variant="detail-muted" TextProps={{ flexGrow: 1 }}>
          <UserDetail variant="name" user={comment.author} />
          <Timestamp variant="timeago" timestamp={comment.created_at} showDot />
        </Typography>
        <Flex gap="0.5rem" flexShrink={0}>
          {actions}
        </Flex>
      </Flex>
      <RenderStaticHtml textHtml={comment.comment} color={textColor} />
    </Flex>
  );
};
